import * as Moment from 'moment'
import { keys, reduce, map, mapValues, mapKeys, compact, omitBy, get, invoke, curry, compose } from 'lodash'
import {asNumber} from "../../util";


const createCheckForRegex = 
(regex) => 
    (value) => 
        regex.test(value)



const rules = {
    number: createCheckForRegex(/^\d+$/),
    numberDecimal: createCheckForRegex(/^\d*\.?\d*$/),
    year: createCheckForRegex(/^\d{4}$/),
     // charLimit:createCheckForRegex(/^[0-9]{1,9}$/),
    name: createCheckForRegex(/^[a-z ,.'-]+$/i),
    phoneNumber: createCheckForRegex(/^[\w+ \(\)-]+$/),
    email: createCheckForRegex(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    ownersCorporationNumber: createCheckForRegex(/^([a-zA-Z0-9/]){1,11}$/),
    lessThanTotalNoOfLots: (x) => (value) => asNumber(value) <= asNumber(x),
    required: (value) => value === 0 || value === "0" || value === false || value === true || ( value != "" && value != undefined && value != null && typeof(value) != "undefined" && typeof(value) != null ),
    isTrueOrFalse: (value) => value === true || value === false,
    isTrue: (value) => value === true,
    date: (value) => Moment( Moment(value, "DD/MM/YYYY").format() ).isValid(),
    greaterThan: (x) => (value) => value > x,
    greaterThanEqual: (x) => (value) => value >= x,
    lessThan: (x) => (value) => value < x,
    lessThanEqual: (x) => (value) => value <= x,
    rangeInclusive: (x, y) => (value) => value >= x && value <= y,
    hasAtLeastOneEntry: (value) => value != null && value != undefined && value.length > 0,
    predicate: (fn) => value => fn(value)
}


const enforceReductionFn = (acc, key) => ({
    ...acc,
    [key]: function() {
        const args = Array.prototype.slice.call(arguments);
        const message = args[args.length-1];
        
        let fn;
        if(args.length == 1){
            fn = rules[key];
        }else{
            const rest = args.slice(0, args.length-1)
            fn = rules[key].apply(this, rest)
        }
        
        return value => fn(value) ? null : message;
    }
})

export const enforce = reduce(keys(rules), enforceReductionFn, {})


const mapMessages = (rules, value) => compact( map(rules, rule => rule(value)) ) //  ([rule1, rule2], "value") => [ "Error 1", "Error 2" ]
const produceErrorArrays = (fields, rulesMap) => mapValues(rulesMap, (rulesArray, fieldId) => mapMessages(rulesArray, get(fields, fieldId)))
const validate = (fields, rulesMap) => omitBy( produceErrorArrays(fields, rulesMap), (errorsArray) => errorsArray.length == 0 )
const doesPass = (value, rules) => reduce(rules, (result, rule) => {
    return result && !rule(value, "BLAH")
}, true);

export default {
    doesPass,
    enforce,
    validate,
    ...rules,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/validation/rules.ts